import { BookConstants } from '@/constants/bookConstants';
import type { Point, Segment } from '@/types/book';

const { POINT_EPSILON } = BookConstants;

export function buildFoldEdgeShadowPath(area: Point[], creaseSegment?: Segment): Point[] {
  if (area.length < 3) return [];
  if (!creaseSegment) return [...area, area[0]];

  const creaseEdgeIndex = area.findIndex((point, index) => {
    const nextPoint = area[(index + 1) % area.length];

    return isSameSegment([point, nextPoint], creaseSegment);
  });

  if (creaseEdgeIndex === -1) return [...area, area[0]];

  const path: Point[] = [];
  const startIndex = (creaseEdgeIndex + 1) % area.length;
  let index = startIndex;

  while (true) {
    path.push(area[index]);
    if (index === creaseEdgeIndex) break;
    index = (index + 1) % area.length;
  }

  return path;
}

function isSameSegment(first: Segment, second: Segment): boolean {
  return (
    (isSamePoint(first[0], second[0]) && isSamePoint(first[1], second[1])) ||
    (isSamePoint(first[0], second[1]) && isSamePoint(first[1], second[0]))
  );
}

function isSamePoint(first: Point, second: Point): boolean {
  return (
    Math.abs(first.x - second.x) <= POINT_EPSILON && Math.abs(first.y - second.y) <= POINT_EPSILON
  );
}
